import { render, staticRenderFns } from "./ShowDetailSubscription.vue?vue&type=template&id=24975691"
import script from "./ShowDetailSubscription.vue?vue&type=script&lang=js"
export * from "./ShowDetailSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports